function initAttachedFile() {
    const attachedBtnList = document.querySelectorAll("[data-attached-btn]");
    if (attachedBtnList && attachedBtnList.length > 0) {
        attachedBtnList.forEach((attachedBtn) => {
            const attachedFileInput = attachedBtn.parentElement.querySelector("[data-input-attach-file]");
            attachedFileInput.addEventListener("change", () => {
                //Name of file and placeholder
                const file = attachedFileInput.files[0].name;
                const label = attachedBtn.querySelector("[data-text-file]");
                label.innerHTML = file;
            });
            attachedBtn.addEventListener("click", () => {
                if (attachedFileInput.classList.contains("error")) {
                    attachedBtn.classList.remove("error");
                    attachedFileInput.classList.remove("error");
                }
            });
        });
    }
}
function initPersonalizedFormCarousel() {
    const flickitySlidersArray = initCarousel("[data-personalized-form-slider]", cellAlign.left, true, false, true, false, false, null, true);
    flickitySlidersArray && flickitySlidersArray.forEach(flickitySlider => {
        //custom binding to buttons
        const prevButton = document.querySelector("[data-prev-button]");
        //custom binding to prev button
        prevButton.addEventListener("click", () => {
            flickitySlider.previous();
        });
        //custom binding to next button
        const nextButton = document.querySelector("[data-next-button]");
        nextButton.addEventListener("click", () => {
            flickitySlider.next();
        });
    });
    personalizedFormSliderActivator();
    showCustomField();
}
const personalizedFormSliderActivator = () => {
    const personalizedFormSliderList = document.querySelectorAll("[data-personalized-form-slider]");
    if (personalizedFormSliderList && personalizedFormSliderList.length > 0) {
        personalizedFormSliderList.forEach((personalizedFormSlider) => {
            const slideList = personalizedFormSlider.querySelectorAll("[data-slide]");
            slideList.forEach((slide) => {
                const checkbox = slide.querySelector("[data-checkbox]");
                slide.addEventListener("click", () => {
                    setTimeout(() => {
                        if (checkbox.checked) {
                            slide.setAttribute("data-active", "active");
                        }
                        else {
                            slide.setAttribute("data-active", "not-active");
                        }
                    }, 0);
                });
            });
        });
    }
};
const showCustomField = () => {
    const haveSimpleList = document.querySelectorAll("[data-have-simple]");
    if (haveSimpleList && haveSimpleList.length > 0) {
        const showHaveSimpleFieldList = document.querySelectorAll("[data-show-have-simple]");
        haveSimpleList.forEach((haveSimple) => {
            const togglerHaveSimple = haveSimple.querySelector("[data-toggler]");
            togglerHaveSimple.addEventListener("change", () => {
                if (togglerHaveSimple.value == "Si") {
                    showHaveSimpleFieldList.forEach((showHaveSimpleField) => {
                        showHaveSimpleField.setAttribute("data-show-have-simple", "visible");
                    });
                }
                else {
                    showHaveSimpleFieldList.forEach((showHaveSimpleField) => {
                        showHaveSimpleField.setAttribute("data-show-have-simple", "not-visible");
                    });
                }
            });
        });
    }
};
